import React from 'react'
import { Modal, ModalProps } from 'antd'
import styles from './index.less'
import { getIsFreeVersionPreCharge, ModalContentType } from '../noticeType'
import { onGoAllOrder } from '@/modules/order/helper'

const bgUrlFree = 'https://assets.sursung.com/activity/20250225/9482D980CCE94F8187C889E696A4B1601740448565906.png'
const bgUrlFindCooper = 'https://assets.sursung.com/activity/20250507/2B41D8D01D3A4FDE90CB163080B46AA31746602591774.png'

export const Content = (props: ModalContentType & ModalProps) => {
    const { onOk, code } = props
    console.log('%c Line:11 🍭 code', 'color:#6ec1c2', code)
    const isFree = getIsFreeVersionPreCharge(code)
    const url = isFree ? bgUrlFree : bgUrlFindCooper
    return (
        <div className={styles.container}>
            <div
                style={{
                    backgroundImage: `url(${url})`
                }}
                className={styles.content}
            />
            <div className={styles.footer}>
                <a className={styles.cancelbtn} onClick={onOk}>
                    我知道了
                </a>
                <a
                    className={styles.btn}
                    onClick={() => {
                        onGoAllOrder({
                            type: 'open'
                        })
                        onOk()
                    }}
                >
                    去推单支付
                </a>
            </div>
        </div>
    )
}

export default (props: ModalContentType & ModalProps) => {
    return (
        <Modal
            {...props}
            footer={false}
            width={720}
            closable={false}
            title={false}
            bodyStyle={{ padding: 0 }}
            keyboard={false}
            maskClosable={false}
            className={styles.modal}
        >
            <Content code={props.code} onOk={props.onOk} />
        </Modal>
    )
}
